module.exports = __webpack_public_path__ + "static/media/upload-placeholder.d91e0b5a.svg";